import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

/**
 * Fetch paginated list of panels from API.
 * @param {Object} [opts] - Additional opts to paginate/filter results.
 * @returns {Promise<Object>} API Response
 */
export const getPanels = (opts = {}) => {
  const query = { ...opts, scope: 'producer' };
  return fetch(getUrl('/panels'), { query });
};

export const getTags = () => (
  fetch(getUrl('/panels/tags'))
);

/**
 * Get list of panels by ID(s).
 * @param {Number} owner - ID of the owner of the panels.
 * @param {Array<String>} ids - List of panels to fetch.
 * @returns <Promise<Object>} API Response
 */
export const getMultiplePanels = (ids = []) => {
  if (!ids.length) {
    return { panels: [] };
  }

  return fetch(getUrl('/panels/many'), {
    query: {
      ids: ids.join(','),
    },
  });
};

/**
 * Duplicate an existing panel by ID.
 * @param {Object} id - ID of the panel to duplicate
 * @returns {Promise<Object>} API Response
 */
export const duplicatePanel = (id) => (
  fetch(getUrl(`/panels/${id}/duplicate`), { method: 'POST' })
);
